
import React from 'react';
import FeatureSummary from "../../../../Util/FeatureSummary";
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../../Table/DetailsTable';

const WebhooksTable = ({
    webhooks,
    setSelectedWebhook,
    loading,
    editOnClick,
    createOnClick,
    previewOnClick,
    deleteOnClick,
}) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu editOnClick={editOnClick} previewOnClick={previewOnClick} id={item.clientID} item={item} deleteOnClick={deleteOnClick} />
            ),
        },
        {
            name: 'ClientName',
            fieldName: 'clientName',
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'CallbackUrl',
            fieldName: 'callbackUrl',
            minWidth: 200,
            maxWidth: 300,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
    ];

    const items = webhooks ?? [];

    const selectionHook = (items) => {
        const selectedItem = items && items[0];
        setSelectedWebhook(selectedItem && selectedItem.clientID);
    };

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                selectionMode="none"
                loading={loading}
                mainColumn={'clientName'}
                style={{
                    position: 'relative',
                    height: '80vh',
                    width: '80vw',
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: 'Edit' }}
                        text="Add Webhook"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                summary="This table displays all configured webhooks for each client, including the client name and the callback URL. You can add, edit, or delete webhooks. Webhooks are used to notify external systems about events in the iGrad platform."
                label="About Webhooks"
            />
        </>
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, deleteOnClick, id, item, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: 'print',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(id),
            },
            {
                key: "Delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () => deleteOnClick(id, item?.clientName || item?.callbackUrl || item?.name || item?.slug || ""),
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
};

export default WebhooksTable;
